import { Grid, Stack } from "@mui/material";
import { useContext, useState } from "react";
import { AmbassadorProfileContext } from "..";
import { updateUserProfile } from "../../../../api/profile";
import { AppChip } from "../../../../components/form";
import ModalBox from "../../../../components/modal";
import { MultiColorProgressbar } from "../../../../components/progressbar";
import { useMutationWithDispatch } from "../../../../hooks/useMutationWithDispatch";
import useToggle from "../../../../hooks/useToggle";
import MyProfileSectionTitle from "../section-title";
import { ENVIRONMENT_LIST } from "./data";
import EditMyEnvironment from "./edit";
import type { EnvironmentValue, UpdateProfileResponse } from "./types";

function Environment() {
  const [openEditModal, setOpenEditModal] = useToggle(false);
  const { data, editMode } = useContext(AmbassadorProfileContext);
  const [environmentList, setEnvironmentList] = useState(data?.environment);

  const { mutateAsync: updateProfile, isPending } = useMutationWithDispatch<
    UpdateProfileResponse,
    { environment: EnvironmentValue }
  >((payload) => updateUserProfile(payload));

  const onSubmit = async () => {
    const res = await updateProfile({ environment: environmentList });
    if (res?.success) {
      setOpenEditModal();
    }
  };

  let sum = 0;

  const onEditCancel = () => {
    setOpenEditModal();
  };

  data &&
    data?.environment &&
    Object.keys(data?.environment)
      ?.filter((i) => data?.environment?.[i] > 0)
      .map((i) => {
        sum += data?.environment?.[i];
      });

  if (!editMode && !data?.environment) return null;

  return (
    <Stack gap={2}>
      <MyProfileSectionTitle
        title={"Environment"}
        subtitle={"Public Cloud Adoption"}
        onEditClick={setOpenEditModal}
        onAddClick={setOpenEditModal}
        operation={!data?.environment ? "ADD" : "EDIT"}
      />

      {data?.environment && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <MultiColorProgressbar
              labels={ENVIRONMENT_LIST.filter((env) => {
                return data?.environment?.[env.field] > 0;
              }).map((env) => {
                return {
                  ...env,
                  value: data?.environment[env.field],
                };
              })}
              withLabel
              elements={ENVIRONMENT_LIST.map((env) => {
                return {
                  value: (data?.environment?.[env.field] / sum) * 100,
                  color: env.color,
                };
              })}
            />
          </Grid>
        </Grid>
      )}

      {openEditModal && (
        <ModalBox
          title={"Edit your profile"}
          onClose={onEditCancel}
          onPrimaryButtonClick={onSubmit}
          primaryButtonProps={{ loading: isPending }}
        >
          {data && (
            <EditMyEnvironment
              value={data?.environment}
              onUpdateEnvironmentList={setEnvironmentList}
            />
          )}
        </ModalBox>
      )}
    </Stack>
  );
}

export default Environment;
